// plugins/apparel-basket.client.ts
import { useApparelStore } from '@S/apparelStore'

export default defineNuxtPlugin(() => {
    const store = useApparelStore()
    store.hydrate()
})
